import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { routePath } from "@/i18n/routes";
import { Kicker, PageHero, Section, CardGrid } from "@/components/Primitives";
import { Button } from "@/components/ui/button";

const RE_IMAGE =
  "https://images.pexels.com/photos/19368932/pexels-photo-19368932.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function RealEstate() {
  const { t, lang } = useI18n();
  return (
    <div data-testid="real-estate-page">
      <Seo pageKey="realEstate" />
      <PageHero kicker={t("realEstate.kicker")} title={t("realEstate.title")} lead={t("realEstate.lead")} image={RE_IMAGE} />

      <Section>
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <p className="text-base leading-relaxed text-foreground/90 sm:text-lg">{t("realEstate.p1")}</p>
            <p data-testid="real-estate-confidentiality" className="mt-8 border-l-2 border-accent pl-6 text-sm leading-relaxed text-muted-foreground">
              {t("realEstate.p2")}
            </p>
          </div>
          <div className="md:col-span-5 flex items-start">
            <Button asChild size="lg" data-testid="real-estate-cta" className="rounded-full bg-accent px-8 text-accent-foreground hover:bg-accent/90">
              <Link to={routePath("apply", lang)}>{t("cta.exploreRealEstate")}</Link>
            </Button>
          </div>
        </div>
      </Section>

      <Section className="bg-secondary/40">
        <Kicker>{t("realEstate.areasKicker")}</Kicker>
        <CardGrid items={t("realEstate.areas")} testIdPrefix="real-estate-area" />
      </Section>
    </div>
  );
}
